module.exports = __webpack_public_path__ + "static/media/bonnie-eisenman.dc8dba76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/bonnie-eisenman.jpg
// module id = 194
// module chunks = 0